












import { Component, Vue } from 'vue-property-decorator'
import buyApi from '@/api/buyApi';

/**
 * 支付状态获取
 */
@Component
export default class extends Vue {
  public mounted() {
    this.getOrderType()
  }

  protected getOrderType() {
    buyApi.checkOrderType({
      orderCode: this.$route.query.orderNo
    }).then((res) => {
      if (res.code === 200) {
        if (res.data.payStatus == 'PAY_SUCCESS') {
          this.$router.push({ name: 'pay-result', query: { success: 'success' } })
        } else if (res.data.payStatus == 'PAY_FAILURE') {
          this.$router.push({ name: 'pay-result' })
        } else if (res.data.payStatus == 'UN_PAID') {
          this.$router.push({ name: 'pay-result' })
        } else {
          setTimeout(() => {
            this.getOrderType()
          }, 3000)
        }
      } else {
        this.$router.push({ name: 'pay-result' })
      }
    })
  }

  protected refresh() {
    window.location.reload()
  }

}
